import { decodeHTML } from 'entities';
import type { Props as FilterTransportProps } from 'Components/widgets/criteria/criteria-transport/filter-transport/FilterTransport';
import 'Components/widgets/criteria/criteria-transport/filter-transport/FilterTransport';
import { DEFAULT_DEPARTURE_CITY } from 'Store/trip-criteria/departure-city/constants';
import { getDepartureCities } from 'Utils/faceting/facetingUtils';
export const getDepartureCitiesFromFacets = (
  facets: Array<any>,
  placeholderLabel: string | null | undefined,
): FilterTransportProps['optionsDepartureCities'] => {
  const departureCities = getDepartureCities(facets);

  if (departureCities.length === 0) {
    return [];
  }

  const options = placeholderLabel
    ? [
        {
          value: '',
          label: placeholderLabel,
        },
      ]
    : [];
  const noTransportOption = departureCities.find((city) => city.value === DEFAULT_DEPARTURE_CITY);

  if (noTransportOption) {
    const { value, label } = noTransportOption;
    options.push({
      value: value as string,
      label: decodeHTML(label as string),
    });
  }

  const citiesOptions = departureCities
    .filter((city) => city.value !== DEFAULT_DEPARTURE_CITY)
    .map(({ label, value }) => ({
      value: value as string,
      label: decodeHTML(label as string),
    }))
    .sort((a, b) => a.value.localeCompare(b.value));
  return [...options, ...citiesOptions];
};
